export const LOGO_URL = "https://customer-assets.emergentagent.com/job_service-platform-61/artifacts/tz4fiame_image.png";

export default function Logo({ size = 40, className = "", showText = false, variant = "default" }) {
  return (
    <div className={`flex items-center gap-3 ${className}`}>
      <div
        className="rounded-md overflow-hidden bg-white flex items-center justify-center shrink-0 ring-1 ring-black/5"
        style={{ width: size, height: size }}
        data-testid="brand-logo"
      >
        <img src={LOGO_URL} alt="Star Capital Landscaping" className="w-full h-full object-contain" />
      </div>
      {showText && (
        <div>
          <div className={`font-display font-bold text-base leading-tight ${variant === "light" ? "text-white" : ""}`}>
            <span>STAR </span>
            <span className="text-primary">CAPITAL</span>
          </div>
          <div className="text-[11px] uppercase tracking-widest text-secondary font-semibold">Landscaping</div>
        </div>
      )}
    </div>
  );
}
